import * as Yup from 'yup';

export const ProfileRequestRecommendationFormValidationSchema = Yup.object().shape(
  {
    Name: Yup.string()
      .nullable()
      .max(255, 'You have exceeded the maximum number of 255 characters')
      .required('Name field is required'),

    Email: Yup.string()
      .nullable()
      .max(100, 'You have exceeded the maximum number of 100 characters')
      .required('Email field is required'),

    Message: Yup.string()
      .nullable()
      .max(1000, 'You have exceeded the maximum number of 1000 characters')
      .required('Comments field is required'),

    TitleID: Yup.object()
      .nullable()
      .required('Title field is required'),
  }
);
